import { ImgHTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

import { getDomainUrl } from 'coreOld/utils';

type WrapperProps = { children?: ReactNode };

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-content: center;
  justify-content: center;
`;

type ImageProps = ImgHTMLAttributes<HTMLImageElement>;

export const Image = styled.img<ImageProps>`
  width: 56px;
  height: 56px;
`;

/** @deprecated */
const PartImage = ({ url, alt }: { url: string; alt: string }) => {
  return (
    <Wrapper>
      <Image src={`${getDomainUrl()}/${url}/h/75/w/75/entire/1`} alt={alt} />
    </Wrapper>
  );
};

export default PartImage;
